import React, { useRef, useEffect, useState, useMemo } from 'react';
import styles from './styles.module.scss';
import COLOR_ORDINAL from '../COLOR_ORDINAL';
import * as d3 from "d3";
import Legend from '../Legend';
import { FIND_STATISTIC_TYPE_BY_VALUE } from '../STATISTIC_TYPES';
import ChartNote from '../ChartNote';
const MOCK_DATA = [
    {
        name: "1萬元~未滿3萬元",
        data: [
            {
                name: "其他",
                value: "1.0527",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "309.7417",
            },
            {
                name: "磚造、加強磚造",
                value: "109.5615",
            },
            {
                name: "木造",
                value: "21.8287",
            },
            {
                name: "鐵皮屋",
                value: "33.3782",
            },
            {
                name: "鋼構",
                value: "3.1490",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.4749",
            },
        ],
    },
    {
        name: "3萬元~未滿5萬元",
        data: [
            {
                name: "其他",
                value: "2.1275",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "473.7194",
            },
            {
                name: "磚造、加強磚造",
                value: "98.8647",
            },
            {
                name: "木造",
                value: "14.0384",
            },
            {
                name: "鐵皮屋",
                value: "30.1869",
            },
            {
                name: "鋼構",
                value: "2.5496",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "1.8527",
            },
        ],
    },
    {
        name: "15萬元~未滿20萬元",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "129.4564",
            },
            {
                name: "磚造、加強磚造",
                value: "5.7220",
            },
            {
                name: "木造",
                value: "1.5814",
            },
            {
                name: "鐵皮屋",
                value: "0.2848",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
        ],
    },
    {
        name: "不到1萬元",
        data: [
            {
                name: "其他",
                value: "3.8590",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "78.7970",
            },
            {
                name: "磚造、加強磚造",
                value: "33.4941",
            },
            {
                name: "木造",
                value: "11.4781",
            },
            {
                name: "鐵皮屋",
                value: "23.7662",
            },
            {
                name: "鋼構",
                value: "0.1844",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
        ],
    },
    {
        name: "沒有收入",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "27.1965",
            },
            {
                name: "磚造、加強磚造",
                value: "6.8594",
            },
            {
                name: "木造",
                value: "0.2317",
            },
            {
                name: "鐵皮屋",
                value: "6.2790",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
        ],
    },
    {
        name: "11萬元~未滿13萬元",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "80.8932",
            },
            {
                name: "磚造、加強磚造",
                value: "15.0681",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.3755",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.2055",
            },
        ],
    },
    {
        name: "7萬元~未滿9萬元",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "274.0617",
            },
            {
                name: "磚造、加強磚造",
                value: "18.2915",
            },
            {
                name: "木造",
                value: "1.1433",
            },
            {
                name: "鐵皮屋",
                value: "5.5268",
            },
            {
                name: "鋼構",
                value: "4.5854",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.7098",
            },
        ],
    },
    {
        name: "5萬元~未滿7萬元",
        data: [
            {
                name: "其他",
                value: "1.6203",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "448.5095",
            },
            {
                name: "磚造、加強磚造",
                value: "81.7505",
            },
            {
                name: "木造",
                value: "10.5602",
            },
            {
                name: "鐵皮屋",
                value: "18.9743",
            },
            {
                name: "鋼構",
                value: "11.3087",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "4.0511",
            },
        ],
    },
    {
        name: "9萬元~未滿11萬元",
        data: [
            {
                name: "其他",
                value: "2.9063",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "304.6595",
            },
            {
                name: "磚造、加強磚造",
                value: "37.8989",
            },
            {
                name: "木造",
                value: "4.8520",
            },
            {
                name: "鐵皮屋",
                value: "1.0429",
            },
            {
                name: "鋼構",
                value: "1.0873",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.4910",
            },
        ],
    },
    {
        name: "25萬元及以上",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "73.8210",
            },
            {
                name: "磚造、加強磚造",
                value: "14.3417",
            },
            {
                name: "木造",
                value: "0.2622",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.7055",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
        ],
    },
    {
        name: "13萬元~未滿15萬元",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "64.3581",
            },
            {
                name: "磚造、加強磚造",
                value: "9.5016",
            },
            {
                name: "木造",
                value: "0.3581",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "1.5679",
            },
        ],
    },
    {
        name: "20萬元~未滿25萬元",
        data: [
            {
                name: "其他",
                value: "0.0000",
            },
            {
                name: "鋼筋混凝土(RC)",
                value: "43.5166",
            },
            {
                name: "磚造、加強磚造",
                value: "2.6430",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鐵皮屋",
                value: "0.7926",
            },
            {
                name: "鋼構",
                value: "3.4486",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
        ],
    },
];

function MultipleLineChart({ data = MOCK_DATA, statisticsType, chartTitle, chart2Title, chart3Title, chartNote }) {
    const svgRef = useRef(null);
    const [legends, setLegends] = useState([]);

    const yAxisTitle = useMemo(() => {
        const foundType = FIND_STATISTIC_TYPE_BY_VALUE(statisticsType);
        return foundType ? foundType.label : "";
    }, [statisticsType]);

    useEffect(() => {
        if (!data || data.length === 0) return;

        // 清除舊的圖表
        d3.select(svgRef.current).selectAll("*").remove();

        // 設定圖表尺寸和邊距
        const margin = { top: 20, right: 40, bottom: 120, left: 60 };
        const width = Math.min(window.innerWidth, 1440) - 360 - margin.left - margin.right;
        const height = 400;

        // 創建 SVG
        const svg = d3
            .select(svgRef.current)
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // 添加剪裁路徑
        svg.append("defs")
            .append("clipPath")
            .attr("id", "chart-area")
            .append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", width)
            .attr("height", height);

        // 創建一個群組來包含背景條紋
        const chartArea = svg.append("g")
            .attr("clip-path", "url(#chart-area)");

        // 獲取所有可能的類別名稱（用於不同的線）
        const categories = data[0].data.map(d => d.name);

        // 設定 x 軸比例尺（收入區間）
        const x = d3
            .scaleBand()
            .domain(data.map(d => d.name))
            .range([0, width])
            .padding(0.1);

        // 設定 y 軸比例尺
        const y = d3
            .scaleLinear()
            .domain([0, d3.max(data, d => d3.max(d.data, item => parseFloat(item.value)))])
            .range([height, 0])
            .nice();

        // 獲取 y 軸的刻度值
        const yTicks = y.ticks(10);

        // 添加垂直背景條紋 (移到 chartArea 中)
        chartArea.selectAll(".background-stripe")
            .data(yTicks)
            .join("rect")
            .attr("class", "background-stripe")
            .attr("x", 0)
            .attr("y", (d, i) => y(yTicks[i]))
            .attr("width", width)
            .attr("height", (d, i) => {
                if (i === yTicks.length - 1) return 0;
                return y(yTicks[i]) - y(yTicks[i + 1]);
            })
            .attr("fill", (d, i) => (i % 2 === 0 ? "#F9F9F9" : "#fff"))
            .attr("opacity", 0.4)
            .attr("stroke", "#D2D2D2")
            .attr("stroke-width", 1);

        // 設定顏色比例尺
        const color = d3
            .scaleOrdinal()
            .domain(categories)
            .range(COLOR_ORDINAL);

        // 創建線條生成器
        const line = d3
            .line()
            .x(d => x(d.name) + x.bandwidth() / 2)
            .y(d => y(parseFloat(d.value)));

        // 為每個類別繪製一條線
        categories.forEach(category => {
            const categoryData = data.map(d => {
                const foundItem = d.data.find(item => item.name === category);
                return {
                    name: d.name,
                    value: foundItem && foundItem.value ? foundItem.value : "0"
                };
            });

            // 繪製線條
            svg.append("path")
                .datum(categoryData)
                .attr("class", "line")
                .attr("fill", "none")
                .attr("stroke", color(category))
                .attr("stroke-width", 2)
                .attr("d", line);

            // 添加數據點
            svg.append("g")
                .selectAll("circle")
                .data(categoryData)
                .join("circle")
                .filter(d => parseFloat(d.value) > 0)
                .attr("cx", d => x(d.name) + x.bandwidth() / 2)
                .attr("cy", d => y(parseFloat(d.value)))
                .attr("r", 4)
                .attr("fill", color(category));
        });

        // 添加 x 軸
        svg.append("g")
            .attr("transform", `translate(0,${height})`)
            .call(d3.axisBottom(x))
            .selectAll("text")
            .attr("transform", "rotate(-25)")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .style("text-anchor", "end")
            .each(function(d) {
                const text = d3.select(this);
                if (!d) {
                    text.text("");
                    return;
                }
                if (d.includes("~")) {
                    const parts = d.split("~");
                    text.text("")
                        .append("tspan")
                        .text(parts[0] + "~")
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text(parts[1])
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else if (d.includes("【訪員請紀錄】")) {
                    const parts = d.split("【訪員請紀錄】");
                    text.text("")
                        .append("tspan")
                        .text(parts[0])
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text("【訪員請紀錄】" + parts[1])
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else if (d.length > 6) {
                    const midpoint = Math.ceil(d.length / 2);
                    const line1 = d.slice(0, midpoint);
                    const line2 = d.slice(midpoint);
                    text.text("");
                    text.append("tspan")
                        .text(line1)
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text(line2)
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                }
            });

        // 添加 y 軸
        svg.append("g")
            .call(d3.axisLeft(y));

        // 設置圖例數據
        setLegends(categories.map(category => ({
            name: category,
            color: color(category)
        })));

    }, [data]);

    return (
        <div className={styles.multipleLineChartContainer}>
            <Legend
                title={chart3Title || chart2Title}
                items={legends}
                className={styles.legend}
            />
            <div className={styles.multipleLineChart}>
                <svg ref={svgRef}></svg>
            </div>
            {chartNote && (
                <ChartNote chartNote={chartNote} />
            )}
        </div>
    );
}

export default MultipleLineChart;